































































































































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
const addnewTalkPoint = () => import("./addnewTalkPoint.vue");
import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetAudioQualityScriptListReq,
  Bool,
  OpenTicketReq,
  AudioQualityScriptData,
  SaveAudioQualityScriptReq,
  GetAudioQualityOptionReq,
} from "@/pbjs/external/ticket/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { CommonIn, ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
  name: "qualityPounts",
  components: {
    addnewTalkPoint,
    // ManualUpgradeTicketDialogue,
  },
})
export default class qualityPounts extends Vue {
  @Prop() num: any;
  @Prop() nxteleOptionsPoint: any;
  @Prop() numflag: any;
  @Prop() QCPointTypeList: any;
  @Prop() teleOptions: any;
  @Prop() qualityobjectmapMap: any;
  @Provide() private isShowSearchRegion: boolean = true;
  @Provide() private nxteleOptionsPoint1: any;
  @Provide() private showDialogType: number = 0;
  @Provide() private Scoring: any = "";
  @Provide() private flag: any = -7;
  @Provide() private QCobject: any = "";
  @Provide() private QCPointType: any = "";
  @Provide() private lang: any = "";
  //  @Provide() private QCPointTypeList: any = [];
  @Provide() private SpellPointHitRules: any = []; //话术点命中规则
  //  @Provide() private qualityobjectmapMap: any = [];//话术点命中规则
  //  @Provide() private teleOptions: any = [];
  @Provide() private nxteleOptions: any = [];
  @Provide() private radio: any = "";
  @Provide() private userForm: any = {
    RulesDescription: null,
    ruleName: null,
    Within: null,
    Repeat: null,
  };
  private created() {
    this.lang = localStorage.getItem("cn");
    this.nxteleOptionsPoint1 = this.nxteleOptionsPoint;
    // this.AudioQualityOptionReq()
    // this.getTicketList()
  }
  private selectRole() {}
  // private emitModel(item:any){
  //    item.
  // }
  @Watch("nxteleOptionsPoint")
  onAmountChanged(val: number | null) {
    this.nxteleOptionsPoint1 = val;
  }
  private deteleList() {
    this.$emit("my-event", this.num.index);
    //通过按钮的点击事件触发方法，然后用$emit触发一个my-event的自定义方法，传递this.msg数据。
  }
  private getruleDataFuc(data: any) {
    this.QCPointType = data.qualitytype;
    //保存失效话术点id
    this.Scoring = data.scriptpoint ? data.scriptpoint.data.id : ""; //scriptname//话术点名称
    let newArr: any = [];
    if (this.nxteleOptionsPoint1) {
      this.nxteleOptionsPoint1.forEach((item: any) => {
        newArr.push(item[0]);
      });
    }
    if (newArr.indexOf(this.Scoring) === -1) {
      this.Scoring = data.scriptpoint.data.scriptname;
    }
    this.SpellPointHitRules == data.scriptpoint ? data.scriptpoint.hitrule : ""; //mingzhong guize
    this.QCobject = data.object; //duixiang
    this.userForm.Within = data.repeatscript
      ? data.repeatscript.continuity
      : "";
    this.userForm.Repeat = data.repeatscript ? data.repeatscript.repeat : "";
  }
  private getRoleListAPIFuc(data: any) {
    this.QCPointTypeList = data.qualitytypemapMap;
    this.teleOptions = data.hitrulemapMap;
    this.qualityobjectmapMap = data.qualityobjectmapMap;
  }
  private async getTicketList() {
    let request: any = new GetAudioQualityScriptListReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(0, 999));
    let requestAuto: any = new AudioQualityScriptData();
    requestAuto.setId();
    requestAuto.setScriptname();
    requestAuto.addScripttext();
    requestAuto.setScriptnum();
    requestAuto.setUid();
    requestAuto.setUsername();
    requestAuto.setCtime();
    requestAuto.setStatus();
    request.setData(requestAuto);
    await ticketClient.getAudioQualityScriptList(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getscriptnameListAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {

          errorMsg(err);
        }
      }
    );
  }
  private forceUpdate() {

    this.$forceUpdate();
  }
  private getscriptnameListAPIFuc(data: any) {
    this.nxteleOptionsPoint1 = [];
    data.listList.forEach((item: any, index: any) => {
      if (item.status == 1) {
        // this.nxteleOptionsPoint.push({ 0: item.id, 1: item.scriptname });
        this.$set(this.nxteleOptionsPoint1, index, {
          0: item.id,
          1: item.scriptname,
        });
      }
    });
    let scoring = this.Scoring;
    this.Scoring = "";
    this.Scoring = scoring;
    // this.nxteleOptionsPoint = this.nxteleOptionsPoint1;
  }
  // //获取下拉列表
  // private AudioQualityOptionReq(){
  //    let request = new GetAudioQualityOptionReq()
  //    request.setCommonin(setCommon());
  //    ticketClient.getAudioQualityOption(request, {}, (err: any, response: any) => {
  //     if (response) {
  //       let data: any = response.toObject();
  //       let _fuc = this.getRoleListAPIFuc;
  //       handleResponse(data, _fuc);
  //     }
  //     if (err) {
  //       errorMsg(err);
  //     }
  //   });

  // }
  private changeList(val: any) {
    this.getTicketList();
  }
  private hideManualUpgradeTicketDialogue(val: any) {
    this.showDialogType = val;
  }
  private addnewTalkPoint() {
    this.showDialogType = 1;
  }
}
